export default __webpack_public_path__ + "static/media/warning-outline.75ef3ab1.svg";